__webpack_require__.p = "/legacy-banner-red/referrals/";